import * as React from "react";
import { useState } from "react";
import logo from "../../../assets/img/logo-1.png";
import { Link, useNavigate } from "react-router-dom";
import styleForgetPassword from "./ForgetPassword.module.css";
import InputElement from "../../form/InputElement";
import { forgotPassowrdPhone } from "../../../adapters/apis/auth/auth";
import Footer from "../../../layouts/footer/Footer";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { isValidPhoneNumber } from "libphonenumber-js";
import { validateBeforeSubmit } from "../../../components/UnifiedTaxDeclaration/helpers/validationHelper";

function ForgotPasswordPhone() {
  const navigate = useNavigate();
  const [newPhone, setNewPhone] = useState({
    mobile: null,
    country_code: "eg",
    dial_code: "20",
  });
  const [mobile, setMobile] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [errMessage, setErrMessage] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [phoneError, setPhoneError] = useState(null);

  const handleChange = (key, value) => {
    setNewPhone((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  function forgetPassword() {
    setMessage("");
    setErrMessage("");
    setPhoneError(null);
    const isPhoneValid = validatePhoneBeforeSubmit();

    if (phoneError === null && isPhoneValid) {
      setLoading(true);
      forgotPassowrdPhone({
        mobile: mobile,
        context: "forgot_password",
      })
        .then((res) => {
          if (res?.data?.responseCode == 429) {
            setErrMessage(res?.data?.message);
            setLoading(false);
          } else {
            localStorage.setItem("context", res?.data?.data?.context);
            localStorage.setItem("mobile", res?.data?.data?.mobile);
            localStorage.setItem("request_code", res?.data?.data?.request_code);
            navigate(
              `/confirm-otp-forget?token=${encodeURIComponent(res?.data?.data?.request_code)}&context=${encodeURIComponent(res?.data?.data?.context)}`,
            );
            setLoading(false);
          }
        })
        .catch((error) => {
          setErrMessage(error?.response?.data?.message);
          setLoading(false);
        })
        .finally(() => {
          // setLoading(false);
        });
    }
  }

  const validatePhoneBeforeSubmit = () => {
    const value = mobile;
    const dialCode = newPhone?.dial_code;
    const countryCode = newPhone?.country_code;
    const nationalNumber = value?.replace(dialCode, "")?.replace(/\D/g, "");
    if (
      value === dialCode ||
      value === "" ||
      value === null ||
      value === undefined
    ) {
      setPhoneError("يجب ادخال رقم الهاتف المحمول");
      return false;
    }

    // Egypt-specific rules
    if (countryCode === "eg") {
      const regex = /^(?:0?)(10|11|12|15)\d{8}$/;
      if (!regex.test(nationalNumber)) {
        setPhoneError(
          "رقم الهاتف المدخل يجب أن يكون رقم هاتف محمول مصريًا صالحًا. يُرجى اختيار مفتاح الدولة (+20) وإدخال رقم هاتف مصري صحيح",
        );
        return false;
      }
    }

    // General validation for other countries
    if (!isValidPhoneNumber("+" + value)) {
      setPhoneError(
        "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول وفقا للدولة المختارة",
      );
      return false;
    }

    // Length rule (≤15 digits excluding country code)
    if (nationalNumber?.length < 6 || nationalNumber?.length > 15) {
      setPhoneError(
        "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول وفقا للدولة المختارة",
      );
      return false;
    }

    setPhoneError(null);
    return true;
  };
  return (
    <>
      <section className={styleForgetPassword["forget-password-section"]}>
        <div className="container">
          <div className="row justify-content-center pt-5">
            <div className="col-md-5">
              <div className={`card ${styleForgetPassword["card"]}`}>
                <div className="text-center">
                  <Link to="/">
                    <img src={logo} alt="Logo" />
                  </Link>
                  <div className="mt-5">
                    <ul class="nav  justify-content-center fs-6 border-0">
                      <li class="nav-item">
                        <Link
                          to="/forget-password-phone"
                          className={`${styleForgetPassword.bgCustom} d-block nav-link py-6 f-16 fw-bold rounded-2`}
                        >
                          رقم الهاتف المحمول
                        </Link>
                      </li>
                      <li class="nav-item">
                        <Link
                          to="/forget-password"
                          className={`${styleForgetPassword.bgGrey} d-block nav-link py-6 f-16 fw-bold rounded-2`}
                        >
                          البريد الإلكترونى
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {message && (
                  <div className="alert alert-primary" role="alert">
                    {message}
                  </div>
                )}
                <div
                  className={`${styleForgetPassword["card-body"]} card-body mt-5 mb-4`}
                >
                  {/* <InputElement
                    allowedPattern={
                      /^0?$|^0(1(0|1|2|5)?)?$|^0(10|11|12|15)\d{0,8}$/
                    }
                    mb4="mb-4"
                    name="mobile"
                    labelHtmlFor="mobile"
                    labelClassName={` required ${styleForgetPassword["form-label"]} form-label`}
                    labelText="رقم الهاتف المحمول"
                    inputType="mobile"
                    inputClassName={`${styleForgetPassword["form-control"]} form-control`}
                    inputID="mobile"
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    value={mobile}
                    onChange={handleChange}
                    pText={errMessage}
                  /> */}
                  <div className="mb-4">
                    <label
                      htmlFor="mobile"
                      className={`required ${styleForgetPassword["form-label"]} form-label`}
                    >
                      رقم الهاتف المحمول
                    </label>

                    <PhoneInput
                      country={"eg"} // default Egypt
                      preferredCountries={[
                        "eg",
                        "sa",
                        "ae",
                        "jo",
                        "kw",
                        "qa",
                        "bh",
                        "om",
                        "ma",
                      ]}
                      value={mobile}
                      onChange={(value, country) => {
                        // When the country changes, reset to just the dial code
                        if (country?.countryCode !== newPhone?.country_code) {
                          value = country?.dialCode;
                        }
                        const nationalNumber = value
                          ?.replace(country?.dialCode, "")
                          ?.replace(/\D/g, "");

                        // ✅ Egypt-specific normalization: remove extra leading 0
                        if (
                          country?.countryCode === "eg" &&
                          nationalNumber?.startsWith("0")
                        ) {
                          value = country?.dialCode + nationalNumber?.slice(1);
                        }

                        // ✅ Length validation, but don’t wipe the value
                        if (
                          (nationalNumber?.length < 6 ||
                            nationalNumber?.length > 15) &&
                          value !== country?.dialCode
                        ) {
                          setPhoneError(
                            "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول وفقا للدولة المختارة",
                          );
                          // keep the current value instead of returning
                          setMobile(value);
                        } else {
                          setPhoneError(null);
                          setMobile(value);
                        }
                        setMobile(value);
                        handleChange("country_code", country?.countryCode);
                        handleChange("dial_code", country?.dialCode);
                      }}
                      inputProps={{
                        name: "mobile",
                        id: "mobile",
                        required: true,
                        className: `phone-control form-control`,
                      }}
                      inputProps={{
                        name: "mobile",
                        id: "mobile",
                        required: true,
                        className: `phone-control form-control`,
                        placeholder: "",
                      }}
                      containerClass="w-100"
                      inputClass="w-100"
                      enableAreaCodes={false}
                      enableSearch={true}
                      countryCodeEditable={false}
                    />

                    {(phoneError || errMessage) && (
                      <p className="text-danger mb-0 mt-2 me-2 fw-bolder">
                        {phoneError || errMessage}
                      </p>
                    )}
                  </div>
                  <div
                    className={`${styleForgetPassword["login-btn"]} text-center my-5`}
                  >
                    <button
                      onClick={forgetPassword}
                      id="set_new_password_button"
                      className={`${styleForgetPassword["btn-login"]} mb-4 d-block`}
                      disabled={loading}
                    >
                      إرسال رمز التحقق
                    </button>
                    <button
                      onClick={() => navigate("/login")}
                      id="back_to_login_button"
                      className={`${styleForgetPassword["btn-bkToLogin"]} mb-4 d-block`}
                    >
                      العودة إلى شاشة تسجيل الدخول
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default ForgotPasswordPhone;
